import React from 'react';

import { type ActivityStatusType } from '@pkg/types';

import { Wrapper } from './styles';

// TODO: This is temporary, move to i18n
const TEXT = {
    listed: 'Listed',
    bid: 'Bid',
    transfer: 'Transfer',
    sale: 'Sale',
    buy: 'Bought',
    mint: 'Mint',
    offer: 'Offer',
    burn: 'Burn',
};

interface ActivityEntryStatusProps {
    status: ActivityStatusType;
}

export function ActivityEntryStatus({ status }: ActivityEntryStatusProps) {
    return <Wrapper $status={status}>{TEXT[status]}</Wrapper>;
}
